import React, { Component } from 'react'
import { FormattedDate, FormattedMessage, FormattedTime, injectIntl, defineMessages } from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx";
import FingerprintDetails from "../../../fingerprint/details.component.jsx";
import { Map, Marker, Popup, TileLayer } from "react-leaflet";
import UAParser from "ua-parser-js";

const messages = defineMessages({
    "quote": {
        id: 'common.signature.quote.label',
        defaultMessage: 'the quote',
    },
    "contract": {
        id: 'common.signature.contract.label',
        defaultMessage: 'the contract',
    },
})

class SignatureCreatedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            proposal: nextProps.proposal || null,
        })
    }


    render() {
        if (!this.state.object) {
            return <div />
        }
        const fingerprint = this.state.object.attributes.fingerprint
        const parser = new UAParser()
        parser.setUA(fingerprint.attributes.userAgent)
        const userAgent = parser.getResult()
        const position = [fingerprint.attributes.cityLatitude, fingerprint.attributes.cityLongitude]
        return <div className={"row " + this.state.className}>
            <div className={'col-12 d-flex align-items-center'}>
                <div className={'mr-3'}>
                    <h3 className={"m-0"}>
                        <Icon value={"signature"} />
                    </h3>
                </div>
                <div >
                    <p className={'mb-0'}>
                        <FormattedMessage
                            id="quote.analytics.events.signature.text"
                            defaultMessage="{name} signed {documentType} on {date}"
                            values={{
                                documentType: this.state.object.attributes.proposalType ?
                                    this.props.intl.formatMessage(messages[this.state.object.attributes.proposalType]) : this.props.intl.formatMessage(messages['quote']),
                                name: <strong>{this.state.object.attributes.firstName} {this.state.object.attributes.lastName}</strong>,
                                date: <strong>
                                    <FormattedDate
                                        year='numeric'
                                        month='long'
                                        day='numeric'
                                        value={new Date(this.state.object.attributes.createdAt)}
                                    />
                                </strong>,
                            }}
                        />
                    </p>
                </div>
            </div>
            <div className={'col-12 border-top mt-2 d-flex'}>
                <div className={'w-100 d-flex align-items-top align-self-stretch flex-wrap'}>
                    <div className={'w-100 w-md-50 p-3'}>
                        <p className="mb-2 bg-super-light border border-light">
                            <img src={this.state.object.attributes.signature} className="w-100 border-bottom border-dark" />
                        </p>
                        <div className={'w-100 d-flex justify-content-between'}>
                            <span>
                                {this.state.object.attributes.firstName} {this.state.object.attributes.lastName}
                            </span>
                            <span>
                                <FormattedDate
                                    year='numeric'
                                    month='long'
                                    day='numeric'
                                    value={new Date(this.state.object.attributes.createdAt)}
                                />
                                &nbsp;
                                <FormattedTime value={new Date(this.state.object.attributes.createdAt)} />
                            </span>
                        </div>
                    </div>
                    <div className={'w-100 w-md-50 px-0 pt-3'}>
                        <div className={'bg-light w-100'}>
                            <div className={'w-100'}>
                                <Map center={position} zoom={10} style={{ height: '125px' }} zoomControl={false} scrollWheelZoom={false}>
                                    <TileLayer
                                        url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                                    />
                                    <Marker position={position}>
                                        <Popup>
                                            {fingerprint.attributes.city.toUpperCase()}, {fingerprint.attributes.regionCode.toUpperCase()}, {fingerprint.attributes.countryCode}
                                        </Popup>
                                    </Marker>
                                </Map>
                            </div>
                            <div className={'w-100 d-flex px-3 py-2'}>
                                <div className={'pr-3'} style={{ fontSize: '2em' }}>
                                    <Icon value={'fingerprint'} />
                                </div>
                                <div className={'flex-grow-1'}>
                                    <div className={'w-100'}>
                                        <small><samp>{fingerprint.attributes.ip}</samp></small>
                                    </div>
                                    <div className={'w-100'}>
                                        <small>
                                            <samp>
                                                {fingerprint.attributes.city.toUpperCase()}, {fingerprint.attributes.regionCode.toUpperCase()}, {fingerprint.attributes.countryCode}
                                            </samp>
                                        </small>
                                    </div>
                                    <div className={'w-100'}>
                                        <small>
                                            <samp>{userAgent.os.name} {userAgent.os.version} / {userAgent.browser.name} {userAgent.browser.version}</samp>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>



                </div>

            </div>


        </div>
    }

}

export default injectIntl(SignatureCreatedEvent)





// WEBPACK FOOTER //
// ./src/quote/analytics/events/signature-created.component.jsx